<ng-template #itemTemplate let-item>
    {{ item.identifier }}
    <ng-container *ngIf="item.description"> - {{ item.description }}</ng-container>
</ng-template>
<ng-template #selectedItemTemplate let-item>
    {{ item.identifier }}
</ng-template>
